import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { APP_CONFIG } from "../config/app-config";
import { CredentialStore } from "../../features/authentication/data-access/credential.store";

export const authTokenInterceptor: HttpInterceptorFn = (request, next) => {
    const config = inject(APP_CONFIG);
    const credentials = inject(CredentialStore).readTokens();
    if (!request.url.startsWith(config.apiBaseUrl)) {
        return next(request);
    }

    const headers: Record<string, string> = {};
    if (config.readonlyApiKey && !request.headers.has("x-gem-api-key")) {
        headers["x-gem-api-key"] = config.readonlyApiKey;
    }
    if (config.webVersion && !request.headers.has("x-version-web")) {
        headers["x-version-web"] = config.webVersion;
    }
    if (credentials?.accessToken && !request.headers.has("x-auth-token")) {
        headers["x-auth-token"] = credentials.accessToken;
    }

    return next(Object.keys(headers).length ? request.clone({ setHeaders: headers }) : request);
};
